import React, { useMemo } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { BuildNavigation, checkAction, findRouteKey } from '././navigationUtils';

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  
  const menu = useMemo(() => JSON.parse(localStorage.getItem("menu")) || [], []);
  const rujul_menu = useMemo(() => JSON.parse(localStorage.getItem("rujul_menu")) || [], []);

  const { alloweObjectIds } = useMemo(() => 
    BuildNavigation(menu, rujul_menu), 
    [menu, rujul_menu]
  );

  const routeKey = findRouteKey(location.pathname);
  
  const isAllowed = alloweObjectIds.includes(Number(routeKey));
  const isPublicRoute = checkAction(location.pathname);

  if (!isAllowed && !isPublicRoute) {
    console.warn(`Unauthorized access attempt to: ${location.pathname}. Redirecting to Home.`);
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;